import { FullPageWrapper } from 'shared/ui'
import { useBroadcastPageContext } from 'pages/broadcasts/context/broadcastsPageContext'
import { BroadcastList } from 'pages/broadcasts/ui/BroacastList'

export const RinglessBroadcasts = () => {
  const storeBroadcastPage = useBroadcastPageContext()

  return (
    <FullPageWrapper>
      <BroadcastList
        storeProps={{ type: 'rvm', pageLayoutStore: storeBroadcastPage.pageLayoutStore }}
      />
    </FullPageWrapper>
  )
}
